/**
 * Single source of truth for "is this a Claude Agent SDK Task* todo tool?"
 *
 * Consumed by:
 *   - apps/sandbox/src/sdk/processor.ts — suppress from transcript wire
 *   - apps/web/src/components/blocks/ToolUseBlock.tsx — render guard
 *   - apps/web/src/components/message-list/GroupedToolBlocks.tsx — pre-grouping filter
 *
 * NOTE: 'Task' (singular, no suffix) is the subagent dispatcher tool — NOT
 * a todo tool. Do not add it here. See memory/task-vocabulary-disambiguation.md.
 */
export const TODO_TOOLS: ReadonlySet<string> = new Set([
  // Legacy Task* names — deprecated, kept during one-release transition window
  'TaskCreate',
  'TaskUpdate',
  'TaskGet',
  'TaskList',
  // New Todo* names (canonical going forward)
  'TodoCreate',
  'TodoUpdate',
  'TodoGet',
  'TodoList',
]);

export function isTodoTool(name: string | undefined | null): boolean {
  return typeof name === 'string' && TODO_TOOLS.has(name);
}
